import { parse } from 'papaparse';

export const headerValidation = (parsedData, requiredFields) => {
  if (parsedData.length > 0) {
    return requiredFields.filter((field) => !parsedData.includes(field));
  }
};

export const parseHandler = (values, setOpen, setMissingFields, requiredFields) => {
  if (values.csv) {
    parse(values.csv, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        const missingFields = headerValidation(results.meta.fields, requiredFields);
        setOpen(Boolean(missingFields?.length > 0));
        setMissingFields(missingFields);
      }
    });
  }
};
